"use client";

import { cn } from "@jesus-central-church/shared";
import React from "react";

/**
 * Grid component - responsive grid layout
 *
 * Spacing system:
 * - Gap: gap-4 sm:gap-6 md:gap-8 (scales with screen)
 * - No container padding (inherits from parent Section)
 */
export function Grid({
  columns,
  children,
  className,
  ...additionalProperties
}: {
  columns?: number;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any;
  children: React.ReactNode;
  className?: string;
}) {
  const colCount = Math.min(columns ?? 2, 3);
  const colCountClass =
    colCount === 1
      ? "grid-cols-1"
      : colCount === 2
        ? "grid-cols-1 sm:grid-cols-2"
        : "grid-cols-1 sm:grid-cols-2 lg:grid-cols-3";

  return (
    <div
      className={cn(
        "grid w-full",
        colCountClass,
        // Consistent gap that scales
        "gap-4 sm:gap-6 md:gap-8",
        className,
      )}
      {...additionalProperties}
    >
      {children}
    </div>
  );
}
